import { getAppConfiguration } from '../helpers/generalFunctions';
import { types } from '../types/types';


const initialState = getAppConfiguration();


export const authReducer = (state =initialState, action) => {
    switch (action.type) {
        case types.authLogin:
            return {
                ...state,
                cheking: false,
                ...action.payload,
            }
        case types.authChekingFinish:
            return {
                ...state,
                cheking: false,
            }    

        case types.authlogout:
            return {
                cheking: false,
            }    
    
        default:
            return state;
    }
    
}